//set global variables
//set id of exitpop
$exitpop = $('#save10');
//set the class name of the close buttons for the exitpop
$exitpopClose = $('.close-box');
//set the page width at which the exitpop will show if it is greater then. (768 pixels is our recommended width)
var exitpopPageWidthRequirement = 0;
//set the page count when you want to show the exitpop (0 = it will show on first page)
var pageToShowOn=0;
//set the name of the exitpop cookie that you would like it to be named.
var nameOfExitpopCookie='customExitpopCookieNameLS2';
//set the percentage of the page scrolled at which you want the exitpop to show (100 = bottom of the page, i.e. 100% scrolled)
var percentOfPageScroll=100;
//set idle time until exitpop shows (milliseconds, i.e. 60000 is 60 seconds)
var exitpopIdleTimeShow = 120000;
//set timeout before mousing into the header will launch the exitpop (milliseconds, i.e. 5000 is 5 seconds)
var exitpopIdleHeaderShow = 10000;
//set how many days you want to have the exitpop not to fire (1 = 1 day until it shows again, set it to -1 if you do not want it to show agin), set to -1 be default
var daysToExpire = -1;

//end variables to be updated by client

//If something on the page is interacted with in any of your other javascript we recommend you set link_clicked=true; 

//don't touch these
var popupShown = false;
var link_clicked = false;
var exitpopCookie=false;
var now = new Date();


$(document).ready(function () {
	//begin popup code
	if(getExitpopCookie(nameOfExitpopCookie)!=''){
		exitpopCookie=true;
	}

    var exitpopPageCount=0;
    if(getExitpopCookie('exitpopPageCountNum')!=''){
        exitpopPageCount=getExitpopCookie('exitpopPageCountNum');
        var newexitpopPageCount= exitpopPageCount+1;
        now.setTime(86400000);
        document.cookie = 'exitpopPageCountNum='+newexitpopPageCount+', expires=' + now.toUTCString() + ', path=/';
    }else{
        now.setTime(86400000);
        document.cookie = 'exitpopPageCountNum=0, expires=' + now.toUTCString() + ', path=/';
    }
    if(exitpopPageCount<pageToShowOn){
        exitpopCookie=true;
    }

	setTimeout(function () {
        if(document.URL.indexOf('challenge') < 0 && document.URL.indexOf('customer_posted') < 0){
		$(window).scroll(function(e){
			var scrollTop = $(window).scrollTop();
			var docHeight = $(document).height();
			var winHeight = $(window).height();
			var scrollPercent = (scrollTop) / (docHeight - winHeight);
			var scrollPercentRounded = Math.round(scrollPercent*100);

			if(scrollPercentRounded==percentOfPageScroll){
				showPopup();
			}
		});
        }
	}, 1000);
  
    setTimeout(function () {
		$(document).mouseleave(function () {
          showPopup();
		});
	}, 10000);

    setTimeout(function () {
        showPopup();           
    }, exitpopIdleTimeShow);

    $('.close-box').on('click touchend', function () {
        $('#save10').hide();

        now = new Date();
        var time = now.getTime();
        if(daysToExpire != -1){
            time += (3600 * 24000)*daysToExpire;
            now.setTime(time);
            document.cookie = nameOfExitpopCookie+'=true, expires=' + now.toUTCString() + ', path=/';
        }
        else{
            document.cookie = nameOfExitpopCookie+'=true, expires=2147483647, path=/';
        }
    });
  
  $('.close-box').on('click touchend', function () {
        $('#save10').hide();

        now = new Date();
        var time = now.getTime();
        if(daysToExpire != -1){
            time += (3600 * 24000)*daysToExpire;
            now.setTime(time);
            document.cookie = nameOfExitpopCookie+'=true, expires=' + now.toUTCString() + ', path=/';
        }
        else{
            document.cookie = nameOfExitpopCookie+'=true, expires=2147483647, path=/';
        }
    });
  
  $('.closeout').on('click touchend', function () {
    	
    //$('.no-thanks').text('Continue Shopping');
    $('#save10').hide();
    	now = new Date();
        var time = now.getTime();
        if(daysToExpire != -1){
            time += (3600 * 24000)*daysToExpire;
            now.setTime(time);
            document.cookie = nameOfExitpopCookie+'=true, expires=' + now.toUTCString() + ', path=/';
        }
        else{
            document.cookie = nameOfExitpopCookie+'=true, expires=2147483647, path=/';
        }
  });

    function getExitpopCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
        
    //show popup
    function showPopup(){
      	if(document.URL.indexOf('challenge') < 0){
          if (!link_clicked && !popupShown && !exitpopCookie && $(window).width() > exitpopPageWidthRequirement) {
              $('#save10').show();
              popupShown = true;
            if($('.footer_success').length > 0)
            $('.footer_success').hide();
          }
        }
    }
    //end popup code
  var urlVal = document.URL;
   if(urlVal.indexOf('customer_posted') > 0){
     showPopup();
     $('html, body').animate({scrollTop: 300}, 2500);
  }
});